import { useApplicantLead } from '@hc-frontend/core-ui';

import { replaceDynamicTextProps } from '../../../pages/typ-dynamic/replaceDynamicTextProps';

export interface UnstyledApplicantTextProps {
  content: string;
}

export default function UnstyledApplicantText({
  content,
}: UnstyledApplicantTextProps) {
  const lead = useApplicantLead();

  if (!lead) {
    return <>{content}</>;
  }

  const outputText = replaceDynamicTextProps({
    lead,
    dynamicText: content,
    partnerName: '',
  });

  return <>{outputText}</>;
}
